import { PulseBaseProvider } from '../../base-classes';

const _getVideoCacheKey = 'getVideoCacheKey';
const _getVideoByPlidCacheKey = 'getVideoByPlidCacheKey';

const _getVideosPath='/api/vid/v2/metadata/category=all';
const _getVideoByPermalinkPath='/api/vid/v2/metadata/permalink=';

export class VideoProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_getVideoCacheKey] = this.getVideosSync.bind(this);
        this.storage.sync[_getVideoByPlidCacheKey] = this.getVideoByPlidSync.bind(this);
    }

    // get 1 or more videos by page number and page size
    async getVideosSync(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            page: syncParams.page,
            pageSize: syncParams.pageSize,
            verbose: syncParams.verbose
        };

        const responseValidator = response => {
            return !!response;
        };

        return await super.syncData(syncParams.key, id, queryParams, _getVideosPath, resolve, reject, responseValidator, syncParams.pulseApi);
    }

    async getVideos(page, pageSize, verbose, stdParameters, refresh = false) {
        const syncParams = {
            page,
            pageSize,
            verbose: !!verbose
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getVideoCacheKey, id);
        }

        return await super.loadFromStorage(_getVideoCacheKey, id, syncParams);
    }

    // get one video by permalinkId
    async getVideoByPlidSync(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            permalinkId: syncParams.permalinkId,
            verbose: syncParams.verbose
        };

        const responseValidator = response => {
            return !!response;
        };

        const queryString = _getVideoByPermalinkPath + queryParams.permalinkId;
        return  await super.syncData(syncParams.key, id, queryParams, queryString, resolve, reject, responseValidator, syncParams.pulseApi);
    }

    async getVideoByPlid(permalinkId, verbose, stdParameters, refresh = false) {
        const syncParams = {
            permalinkId,
            verbose: !!verbose
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getVideoByPlidCacheKey, id);
        }

        return await super.loadFromStorage(_getVideoByPlidCacheKey, id, syncParams);
    }
}
